<div class="under-construction">
    <mat-icon color="warn" class="icon">build</mat-icon>
    <h2>Under Construction</h2>
    <p>This feature is coming soon!</p>
</div>